export const responsiblesSelector = state => state.responsibles.results?.valueSeq()?.toArray()

export const userAgentsSelector = state =>
  state.responsibles.get('userAgents')?.valueSeq()?.toArray()
